var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E9EBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 15.75C20.75 18.5114 18.5114 20.75 15.75 20.75C12.9886 20.75 10.75 18.5114 10.75 15.75C10.75 12.9886 12.9886 10.75 15.75 10.75C18.5114 10.75 20.75 12.9886 20.75 15.75Z",
    fill: "#238856"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 5C16.1642 5 16.5 5.33579 16.5 5.75V7.75C16.5 8.16421 16.1642 8.5 15.75 8.5C15.3358 8.5 15 8.16421 15 7.75V5.75C15 5.33579 15.3358 5 15.75 5ZM5 15.75C5 15.3358 5.33579 15 5.75 15H7.75C8.16421 15 8.5 15.3358 8.5 15.75C8.5 16.1642 8.16421 16.5 7.75 16.5H5.75C5.33579 16.5 5 16.1642 5 15.75ZM23 15.75C23 15.3358 23.3358 15 23.75 15H25.75C26.1642 15 26.5 15.3358 26.5 15.75C26.5 16.1642 26.1642 16.5 25.75 16.5H23.75C23.3358 16.5 23 16.1642 23 15.75ZM15.75 23C16.1642 23 16.5 23.3358 16.5 23.75V25.75C16.5 26.1642 16.1642 26.5 15.75 26.5C15.3358 26.5 15 26.1642 15 25.75V23.75C15 23.3358 15.3358 23 15.75 23Z",
    fill: "#238856"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41524 7.46658C7.69474 7.16088 8.16914 7.13965 8.47484 7.41915L10.6969 9.45073C11.0026 9.73023 11.0238 10.2046 10.7443 10.5103C10.4648 10.816 9.99039 10.8373 9.6847 10.5578L7.46268 8.52618C7.15698 8.24668 7.13574 7.77228 7.41524 7.46658Z",
    fill: "#238856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0802 7.46658C24.3597 7.77228 24.3385 8.24668 24.0328 8.52618L21.8107 10.5578C21.505 10.8373 21.0306 10.816 20.7511 10.5103C20.4716 10.2046 20.4929 9.73023 20.7986 9.45073L23.0206 7.41915C23.3263 7.13965 23.8007 7.16088 24.0802 7.46658Z",
    fill: "#238856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7744 20.7763C21.0673 20.4834 21.5421 20.4835 21.835 20.7764L24.057 22.9987C24.3499 23.2916 24.3499 23.7664 24.057 24.0593C23.7641 24.3522 23.2892 24.3522 22.9963 24.0592L20.7743 21.837C20.4814 21.544 20.4815 21.0692 20.7744 20.7763Z",
    fill: "#238856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7213 20.7763C11.0142 21.0691 11.0142 21.544 10.7213 21.8369L8.49908 24.0591C8.20618 24.352 7.73132 24.352 7.43843 24.0591C7.14553 23.7662 7.14553 23.2914 7.43843 22.9985L9.66065 20.7762C9.95354 20.4834 10.4284 20.4834 10.7213 20.7763Z",
    fill: "#238856"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSun);
export default __webpack_public_path__ + "static/media/greenSun.904c107a670f1158a9c31bc6ada20748.svg";
export { ForwardRef as ReactComponent };